import HTTP from '@/plugins/http';

const usdtApi = {
  auth: '/merchant/captcha/auth',
  byNo: '/merchant/byNo',
  accounts: '/merchant/usdt/account/list/page',
  create: '/merchant/usdt/account/add',
  update: '/merchant/usdt/account/update',
  delete: '/merchant/usdt/account/delete',
  orders: '/merchant/usdt/list/page',
  withdrawOrders: '/withdraw/usdt/list/page',
  count: '/withdraw/usdt/count',
  countOrders: '/merchant/usdt/count',
  callbackOrder: '/merchant/usdt/manual/callback/',
  manual: '/merchant/usdt/manual/makeup/',
  withdraw: '/merchant/usdt/withdraw',
  wallets: '/withdrawUsdt/getByMerchatNo',
  USDTBalance: '/merchant/wallet/usdt/amount',
  review: '/withdraw/usdt/review',
  exportWithdraw: '/withdrawOrder/usdt/export',
  exportOrder: '/merchant/usdt/list'
};

function exportOrder(data) {
  return HTTP.loading({
    url: usdtApi.exportOrder,
    method: "post",
    responseType: "blob",
    data
  });
}

function exportWithdrawOrder(data) {
  return HTTP.loading({
    url: usdtApi.exportWithdraw,
    method: "post",
    responseType: "blob",
    data
  });
}

export function doReview(data) {
  return HTTP({
    url: usdtApi.review,
    method: 'post',
    data
  });
}

export function getAuth(params) {
  return HTTP.loading({
    url: usdtApi.auth,
    method: 'get',
    params
  });
}

export function getmerchantNo(data) {
  return HTTP({
    url: usdtApi.byNo,
    method: 'post',
    data
  });
}

export function getSummary({ merchantNo }) {
  return HTTP.loading({
    url: `${usdtApi.USDTBalance}?merchantNo=${merchantNo}`,
    method: 'get',
  });
}

export function getBank({ merchantNo }) {
  return HTTP.loading({
    url: `${usdtApi.wallets}?merchatNo=${merchantNo}`,
    method: 'get',
  });
}

export function makeupOrder({ systemOrderNo }) {
  return HTTP.loading({
    url: `${usdtApi.manual}${systemOrderNo}`,
    method: 'get',
  });
}

export function callbackOrder({ systemOrderNo }) {
  return HTTP.loading({
    url: `${usdtApi.callbackOrder}${systemOrderNo}`,
    method: 'get',
  });
}

export function doWithdraw(data) {
  return HTTP({
    url: usdtApi.withdraw,
    method: 'post',
    data
  });
}

export function countWithdrawOrder(data) {
  return HTTP({
    url: usdtApi.count,
    method: 'post',
    data
  });
}

export function countUSDTOrders(data) {
  return HTTP({
    url: usdtApi.countOrders,
    method: 'post',
    data
  });
}

export function getUSDTOrders({ data }) {
  return HTTP({
    url: usdtApi.orders,
    method: 'post',
    data,
  });
}

export function getWithdrawOrders({ data }) {
  return HTTP({
    url: usdtApi.withdrawOrders,
    method: 'post',
    data,
  });
}

export function getAccountList({ data }) {
  return HTTP({
    url: usdtApi.accounts,
    method: 'post',
    data,
  });
}

export function createAccount(data) {
  return HTTP({
    url: usdtApi.create,
    method: 'post',
    data
  });
}

export function deleteAccount(data) {
  return HTTP({
    url: usdtApi.delete,
    method: 'post',
    data
  });
}

export function updateAccount(data) {
  return HTTP({
    url: usdtApi.update,
    method: 'post',
    data
  });
}

export default {
  getAccountList,
  createAccount,
  updateAccount,
  deleteAccount,
  makeupOrder,
  callbackOrder,
  countWithdrawOrder,
  countUSDTOrders,
  getUSDTOrders,
  getWithdrawOrders,
  doWithdraw,
  getBank,
  getmerchantNo,
  getSummary,
  doReview,
  exportOrder,
  exportWithdrawOrder
};



// WEBPACK FOOTER //
// ./src/api/usdt.js